var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconKnowledgeCentre = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35.539 30.299",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -7.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.323H6.386v3.193H0Zm0,4.47H6.386V33.506H0ZM1.171,29.488a2,2,0,1,0,2-2A2,2,0,0,0,1.171,29.488ZM0,37.338H6.386V34.784H0Zm7.663-3v3h8.3V34.321c-.339-.242-1.392-.814-3.832-.814A10.77,10.77,0,0,0,7.663,34.337Zm0-18.371a10.787,10.787,0,0,0,4.47.831c2.424,0,3.48-.566,3.832-.819V13.709h-8.3Zm0,1.383V32.954a12.744,12.744,0,0,1,4.47-.724,9.551,9.551,0,0,1,3.832.645V17.43a9.573,9.573,0,0,1-3.832.644A12.758,12.758,0,0,1,7.663,17.349ZM29.507,7.18l-4.379.9.642,3.128,4.379-.9Zm5.262,25.65-4.378.9L26.026,12.458l4.379-.9ZM33.25,29.038A1.818,1.818,0,0,0,31.325,27.4,1.817,1.817,0,0,0,30.2,29.665a1.816,1.816,0,0,0,1.925,1.641A1.816,1.816,0,0,0,33.25,29.038Zm1.776,5.041-4.38.9.514,2.5,4.379-.9ZM17.881,10.516h6.386V7.323H17.881Zm0,26.822h6.386V34.784H17.881Zm0-7.025h6.386V14.987H17.881Zm0,3.193h6.386V31.591H17.881Zm0-19.8h6.386V11.794H17.881Z",
    transform: "translate(0 0)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconKnowledgeCentre, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-knowledge-centre.490c3bf6.svg";
export { ForwardRef as ReactComponent };